import apiClient from "./apiClient";

export const uploadMedia = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  const { data } = await apiClient.post("/media", formData);
  return data.data;
};
